import * as Sentry from '@sentry/node'
import { RewriteFrames } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import getConfig from 'next/config'

// const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL
const TRACES_SAMPLE_RATE = process.env.NEXT_PUBLIC_TRACES_SAMPLE_RATE || '0.05'

export function urlToRoute(url, slug = '/{id}') {
  return url
    .replace(/\?.*/, '') // remove query
    .replace(/^[^/]+\/(?!\/)/, '/') // remove host
    .replace(/\/(\d+|[abcdef\d]{24})\b/g, slug) // replace params
}

export function init() {
  if (!process.env.NEXT_PUBLIC_SENTRY_DSN) return
  const config = getConfig()
  const distDir = `${config.serverRuntimeConfig.rootDir}/.next`

  Sentry.init({
    enabled: process.env.NODE_ENV === 'production',
    integrations: [
      new RewriteFrames({
        iteratee: (frame) =>
          Object.assign(frame, {
            filename: frame.filename.replace(distDir, 'app:///_next'),
          }),
      }),
      new Integrations.BrowserTracing({
        beforeNavigate: (ctx) => ({
          ...ctx,
          // for each dynamic page a RegExp required
          name: urlToRoute(window.location.pathname, '/[id]'),
        }),
        // https://docs.sentry.io/platforms/javascript/performance/#tracingorigins
        // Allow Header 'sentry-trace' to trace file upload in NOP-73
        // Else upload request may be blocked in browser
        // tracingOrigins: ['localhost', /^\//, BASE_URL],
      }),
    ],
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    release: process.env.NEXT_PUBLIC_RELEASE,
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    tracesSampleRate: Number(TRACES_SAMPLE_RATE) || 0,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Failed to fetch',
      'Could not identify user.',
    ],
  })
}

export function setUser(value) {
  if (!process.browser || !localStorage.getItem('auth')) {
    Sentry.setUser(value)
    return
  }

  const {
    user: {
      su: [
        {
          id: suid,
          rolename: surole,
          status: sustatus,
          schoolid,
          schoolstatus,
        },
      ],
      id,
      name,
      emailid,
      mobile,
      rolename,
      status,
    },
  } = JSON.parse(localStorage.getItem('auth'))

  Sentry.setUser({
    id,
    name,
    username: mobile.toString(),
    email: emailid,
    mobile,
    rolename,
    status,
    school_user: {
      id: suid,
      rolename: surole,
      status: sustatus,
      schoolid,
      schoolstatus,
    },
  })
}
